import { useEffect, useState } from "react";

export function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("pr_cookie_consent")) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("pr_cookie_consent", "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:max-w-md z-[60] bg-espresso text-ivory rounded-2xl p-6 shadow-2xl border border-champagne/30"
    >
      <p className="text-sm text-ivory/80 leading-relaxed">
        We use essential cookies to keep this site running smoothly and to understand how it's used.
        By continuing, you agree to our use of cookies.
      </p>
      <div className="flex gap-3 mt-4">
        <button
          onClick={accept}
          data-testid="cookie-accept"
          className="bg-champagne text-espresso rounded-full px-5 py-2 text-sm font-medium hover:bg-ivory transition-colors"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
